// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddressWarning_wrapper__g6-2v","button":"AddressWarning_button__2CBIo","smart-contract-warning":"AddressWarning_smart-contract-warning__3Lhqo"};